


























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "SourceCodeContainer"
})
export default class SourceCodeContainer extends Vue {}
